import { Dialog, DialogProps, Grid } from '@material-ui/core';
import React, { useState } from 'react';
import CloseButton from 'reusableComponents/CloseButton';
import { useWidth } from 'reusableComponents/useWidth';
import InviteForm from './components/InviteForm';
import InviteSent from './components/InviteSent';

interface IProps extends DialogProps {
    onClose: () => void;
    inviteLink: string;
}
export default function InviteModal({ inviteLink, onClose, ...props }: IProps) {
    const breakpoint = useWidth();
    const [lastSentTo, setLastSentTo] = useState('');
    const [page, setPage] = useState(0);

    const pages = [
        <InviteForm
            onSubmit={(email: string) => {
                setLastSentTo(email);
                setPage(1);
            }}
            inviteLink={inviteLink}
            referralContext={'Group: Share via Email'}
        />,
        <InviteSent sendAction={() => setPage(0)} closeAction={onClose} sentTo={lastSentTo} />,
    ];

    return (
        <Dialog maxWidth="sm" fullWidth fullScreen={breakpoint === 'xs'} {...props} onClose={onClose}>
            <Grid container style={{ padding: 30 }}>
                <CloseButton onClose={onClose} />
                {pages[page]}
            </Grid>
        </Dialog>
    );
}
